<template>
  <div :class="layoutType" class="h-100 d-flex flex-column">
    <div class="flex-grow-1 overflow-auto mcf-bg" ref="scrollContainer">
      <!-- header begin -->
      <HeaderMobile class="mb-3" :title="title" :headerBackground="headerBackground" @changeDetailDepts="setDeptDropdownMenu"></HeaderMobile>
      <!-- header end -->
      <div class="container">
        <div class="row justify-content-between align-items-center mb-3">
          <!-- 分類下拉 begin -->
          <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
            <b-form-select v-if="dropdown.show" v-model="dropdown.selected" :options="dropdown.options" size="" class="bg-white"></b-form-select>
          </div>
          <!-- 分類下拉 end -->
          <!-- 可用點數 begin -->
          <div class="col-12 col-md-5 col-lg-4">
            <UsablePoint v-if="hasLogged" class="justify-content-lg-end" />
          </div>
          <!-- 可用點數 end -->
        </div>
        <!-- 兌禮列表 begin -->
        <RedeemList></RedeemList>
        <!-- 兌禮列表 end -->
        <!-- 猜你喜歡 begin -->
        <!--
        <h6 class="text-mcf-color">猜你喜歡</h6>
        <McfProductList></McfProductList>
        -->
        <!-- 猜你喜歡 end -->
      </div>
    </div>
    <BottomSheet :isOpen="!isRedeemList" @update:isOpen="closeDetail()">
      <div class="flex-grow-1 overflow-auto mt-4">
        <div class="container px-4">
          <router-view></router-view>
        </div>
      </div>
      <div class="position-sticky mcf-bg-defualt" style="bottom:0">
        <CartButton v-if="showCartButton" class="position-sticky animate__animated animate__bounceInUp" />
      </div>
    </BottomSheet>
    <!-- 置底兌換按鈕，計數器有數量才出現 begin -->
    <div class="position-sticky mcf-bg-defualt" style="bottom:0">
      <CartButton v-if="showCartButton" class="position-sticky animate__animated animate__bounceInUp" />
      <FooterMobile :currentItem="currentFooterItem" />
    </div>
    <!-- 置底兌換按鈕，計數器有數量才出現 end -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CartButton from '@/components/redeem/CartButton.vue';
import FooterMobile from '@/components/FooterMobile.vue';
import HeaderMobile from '@/components/redeem/HeaderMobile.vue';
import RedeemList from '@/components/redeem/RedeemList.vue';
import UsablePoint from '@/components/redeem/UsablePoint.vue';
import BottomSheet from '@/components/BottomSheet.vue';

import pageSettingGetter from '@/utils/pageSettingGetter';

let deptNoList = [];

export default {
  components: {
    CartButton,
    FooterMobile,
    HeaderMobile,
    RedeemList,
    UsablePoint,
    BottomSheet,
  },
  data() {
    return {
      // 標題
      title: '',
      // header背景圖
      headerBackground: '',
      // 下拉選單
      dropdown: {
        // 選擇的項目
        selected: null,
        // 項目列表
        options: [],
        // 是否顯示
        show: false,
      },
      // 顯示購物車按鈕
      showCartButton: false,
      // 兌禮詳情是否從外部開啟
      isDetailAccessedFromOutside: true,
      // 當前頁尾項目
      currentFooterItem: 'RedeemItem',
    };
  },
  computed: {
    ...mapState(['layoutType']),
    ...mapState('redeemItem', ['cartList']),
    // 是否登入
    hasLogged() {
      return !!this.$store.state.accessToken;
    },
    // 是否為兌禮列表頁
    isRedeemList() {
      const vm = this;
      return vm.$route.name === 'redeemList';
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'dropdown.selected': function(newValue) {
      const vm = this;
      // 選擇"請選擇選擇分類"時，取得所有子分類下兌禮商品資料
      if (!newValue) {
        vm.$store.commit('redeemItem/setItemDeptNoList', deptNoList);
        return;
      }
      // 設定最愛商品編號列表，列表用
      vm.$store.commit('redeemItem/setItemDeptNoList', newValue);
    },
    // 監控購物車列表
    cartList(newValue) {
      // 有資料就顯示購物車 (僅針對第一次進入頁面，不處理清空狀態)
      if (newValue.length) this.showCartButton = true;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const vm = this;
    if (to.name === 'redeemDetail') vm.isDetailAccessedFromOutside = false;
    next();
  },
  created() {
    const vm = this;

    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
        // header背景
        vm.headerBackground = setting.backgroundMobilePic;
      });

    // 未登入顯示購物車未登入 bar
    if (!vm.hasLogged) vm.showCartButton = true;
  },
  methods: {
    // 設定分類下拉選單
    setDeptDropdownMenu(depts) {
      const vm = this;
      // 沒有子分類下拉選單不顯示，直接return
      if (!depts.length) {
        vm.dropdown.show = false;
        return;
      }

      vm.dropdown.show = true;
      // 設定選項
      vm.dropdown.options = depts.map((x) => ({
        value: [x.no],
        text: x.name,
      }));

      // 預設選擇選項
      deptNoList = depts.map((x) => (x.no));
      vm.dropdown.selected = null;
      vm.dropdown.options.unshift({
        value: null,
        text: vm.$t('redeem.dept.please-select-dept'),
      });

      // 切換主分類時，重取所有子分類下兌禮商品資料
      vm.$store.commit('redeemItem/setItemDeptNoList', deptNoList);
    },
    // 關閉兌禮詳情
    closeDetail() {
      const vm = this;
      // 若兌禮詳情是從外部開啟，replace到兌禮列表
      if (vm.isDetailAccessedFromOutside) vm.$router.replace({ name: 'redeemList', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
      // 若兌禮詳情是從兌禮列表開啟，回上一頁
      else vm.$router.go(-1);
    },
  },
};
</script>
